/** Współdzielone helpery terminów dla widgetów dashboardu. */

const pluralDni = (n: number) => (n === 1 ? 'dzień' : 'dni');

/** Polska etykieta terminu: „dziś" / „za N dni" / „N dni po terminie". */
export function dniLabel(days: number): string {
  if (days === 0) return 'dziś';
  if (days > 0) return `za ${days} ${pluralDni(days)}`;
  const n = -days;
  return `${n} ${pluralDni(n)} po terminie`;
}
